import styled from 'styled-components';
import { Button } from '../../../../input/Button';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionBudgetGoals' })
    .attrs({
        width: '100%',
    })``;

export const AddGoalButton = styled(Button)
    .withConfig({ displayName: 'AddGoalButton' })
    .attrs((props) => ({
        ...props,
        variant: 'filled',
        color: 'secondary',
        size: 'l',
        mt: 2,
    }))``;
